"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var WebServerBase_1 = require("../base/WebServerBase");
var convert_1 = require("../../utils/convert");
var types_1 = require("./types");
var core_decorators_1 = require("core-decorators");
var controllerName = 'WebClient';
var ControllerWebClient = /** @class */ (function () {
    function ControllerWebClient(webServer) {
        this._webServer = webServer;
    }
    ControllerWebClient.prototype.GetLocalization = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var flatFilter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flatFilter = convert_1.convertObjectToIParametersDictionary(filter);
                        return [4 /*yield*/, this._webServer.fetch(controllerName, 'GetLocalization', flatFilter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetBillboards = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var flatFilter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flatFilter = convert_1.convertObjectToIParametersDictionary(filter);
                        return [4 /*yield*/, this._webServer.fetch(controllerName, 'GetBillboards', flatFilter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetProperties = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var arr, flatFilter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        arr = {};
                        (filter.propertyValueSetIds || []).forEach(function (value, index) {
                            arr["propertyValueSetIds[" + index + "]"] = value.toString();
                        });
                        flatFilter = convert_1.convertObjectToIParametersDictionary(arr);
                        return [4 /*yield*/, this._webServer.fetch(controllerName, 'GetProperties', flatFilter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetCustomers = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'GetCustomers', filter)];
                    case 1:
                        response = _a.sent();
                        if (response.Result) {
                            response.Result = response.Result.map(function (c) { return new types_1.ClientInfo(c); });
                        }
                        ;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.SearchCallsInfo = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'SearchCallsInfo', filter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetAllCompanies = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ;
                        return [4 /*yield*/, this._webServer.fetch(controllerName, 'GetAllCompanies', {})];
                    case 1:
                        response = _a.sent();
                        if (response.Result) {
                            response.Result = response.Result.map(function (c) { return new types_1.ClientInfo(c); });
                        }
                        ;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetBrands = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ;
                        return [4 /*yield*/, this._webServer.fetch(controllerName, 'GetBrands', {})];
                    case 1:
                        response = _a.sent();
                        if (response.Result) {
                            response.Result = response.Result.map(function (brand) { return new types_1.EmployeeBrandsInfo(brand); });
                        }
                        ;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetCustomerRoles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ;
                        return [4 /*yield*/, this._webServer.fetch(controllerName, 'GetCustomerRoles', {})];
                    case 1:
                        response = _a.sent();
                        if (response.Result) {
                            response.Result = response.Result.map(function (role) { return new types_1.RolesInfo(role.key, role.text); });
                        }
                        ;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.SaveClient = function (client) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'SaveClient', client)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetClientByINN = function (inn) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, apiResponse, webApiFailResponse, innInfo, clientInfo, webApiSuccessResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this._webServer.GetWebApiUrl() + "/webapi?q=get_requisites&inn=" + inn;
                        return [4 /*yield*/, fetch(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, WebServerBase_1.getApiResponse(response)];
                    case 2:
                        apiResponse = _a.sent();
                        if (apiResponse.Success && apiResponse.Result !== undefined) {
                            if (apiResponse.Result.Success === false) {
                                webApiFailResponse = __assign(__assign({}, apiResponse), { Success: false, Message: apiResponse.Result.Message, Result: undefined });
                                return [2 /*return*/, webApiFailResponse];
                            }
                            innInfo = apiResponse.Result.Data.suggestions[0].data;
                            clientInfo = types_1.ClientInfo.fromInnData(innInfo);
                            webApiSuccessResponse = __assign(__assign({}, apiResponse), { Result: clientInfo });
                            return [2 /*return*/, Promise.resolve(webApiSuccessResponse)];
                        }
                        return [2 /*return*/, apiResponse];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetPropertySet = function (propertyValueSetId) {
        return __awaiter(this, void 0, void 0, function () {
            var flatFilter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flatFilter = convert_1.convertObjectToIParametersDictionary({ "propertyValueSetId": propertyValueSetId });
                        return [4 /*yield*/, this._webServer.fetch(controllerName, 'GetPropertySet', flatFilter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.SavePropertySet = function (propertySet) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'SavePropertySet', propertySet)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.SetGeoMark = function (geomark) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'SetGeoMark', geomark)];
                    case 1:
                        response = _a.sent();
                        response.Result = geomark;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetGeoMarkTimeStatuses = function (geoMarkId, dateStart, dateEnd) {
        return __awaiter(this, void 0, void 0, function () {
            var flatFilter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flatFilter = convert_1.convertObjectToIParametersDictionary({
                            "geoMarkId": geoMarkId,
                            "dateStart": dateStart,
                            "dateEnd": dateEnd
                        });
                        return [4 /*yield*/, this._webServer.fetch(controllerName, 'GetGeoMarkTimeStatuses', flatFilter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetGeoMarksTimeStatuses = function (geoMarkIds, dateStart, dateEnd) {
        return __awaiter(this, void 0, void 0, function () {
            var flatFilter, body, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flatFilter = convert_1.convertObjectToIParametersDictionary({
                            "dateStart": dateStart,
                            "dateEnd": dateEnd
                        });
                        body = geoMarkIds;
                        return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'GetGeoMarksTimeStatuses', body, flatFilter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetGeoMarkTimeStatusesByProjectIds = function (projectIds) {
        return __awaiter(this, void 0, void 0, function () {
            var body, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = projectIds;
                        return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'GetGeoMarkTimeStatusesByProjectIds', body)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetGeoMarkTariffs = function (geoMarkIds) {
        return __awaiter(this, void 0, void 0, function () {
            var body, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = geoMarkIds;
                        return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'GetGeoMarkTariffs', body)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.SetGeoMarkTimeStatuses = function (status) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'SetGeoMarkTimeStatuses', status)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.SaveSystemEvent = function (eventName, parameters) {
        return __awaiter(this, void 0, void 0, function () {
            var eventWithParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eventWithParameters = {
                            eventName: eventName,
                            parameters: parameters
                        };
                        return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'SaveSystemEvent', eventWithParameters)];
                    case 1:
                        response = _a.sent();
                        response.Result = response.Success;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.SaveSystemEvent_Unsafe = function (eventName, parameters) {
        return __awaiter(this, void 0, void 0, function () {
            var eventWithParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eventWithParameters = {
                            eventName: eventName,
                            parameters: parameters
                        };
                        return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'SaveSystemEvent', eventWithParameters)];
                    case 1:
                        response = _a.sent();
                        response.Result = response.Success;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.SetBillboardPhoto = function (geoMarkId, sideName, selectedPhoto) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._webServer.fetchPOST(controllerName, "SetBillboardPhoto?geoMarkId=" + geoMarkId + "&sideName=" + sideName, selectedPhoto, null, true)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.DeleteBillboardPhoto = function (geoMarkId, sideName) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._webServer.fetchPOST(controllerName, "DeleteBillboardPhoto?geoMarkId=" + geoMarkId + "&sideName=" + sideName)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetAdditionalBillboardInfo = function (geoMarkId) {
        return __awaiter(this, void 0, void 0, function () {
            var flatFilter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flatFilter = convert_1.convertObjectToIParametersDictionary({
                            "geoMarkId": geoMarkId
                        });
                        return [4 /*yield*/, this._webServer.fetch(controllerName, 'GetAdditionalBillboardInfo', flatFilter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.DeleteGeoMartTimeStatuses = function (geoMarkTimeStatusIds) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'DeleteGeoMartTimeStatuses', geoMarkTimeStatusIds)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GenerateOffer = function (projectId) {
        return __awaiter(this, void 0, void 0, function () {
            var flatFilter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flatFilter = convert_1.convertObjectToIParametersDictionary({
                            "projectId": projectId
                        });
                        return [4 /*yield*/, this._webServer.fetchFile(controllerName, 'GenerateOffer', flatFilter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.GetCommercialOffer = function (offerId, projectId) {
        if (offerId === void 0) { offerId = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var flatFilter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flatFilter = convert_1.convertObjectToIParametersDictionary({
                            "offerId": offerId,
                            "projectId": projectId,
                        });
                        return [4 /*yield*/, this._webServer.fetch(controllerName, 'GetCommercialOffer', flatFilter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.PrepareOfferMail = function (offerId, mailText) {
        if (offerId === void 0) { offerId = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var flatFilter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flatFilter = convert_1.convertObjectToIParametersDictionary({
                            "offerId": offerId,
                            "mailText": mailText,
                        });
                        return [4 /*yield*/, this._webServer.fetchHtml(controllerName, 'PrepareOfferMail', flatFilter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerWebClient.prototype.SetGeoMarkTariffs = function (tariffInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._webServer.fetchPOST(controllerName, 'SetGeoMarkTariffs', tariffInfo)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    __decorate([
        core_decorators_1.deprecate('Use GetGeoMarksTimeStatuses')
    ], ControllerWebClient.prototype, "GetGeoMarkTimeStatuses", null);
    __decorate([
        core_decorators_1.deprecate('Use SaveSystemEvent')
    ], ControllerWebClient.prototype, "SaveSystemEvent_Unsafe", null);
    __decorate([
        core_decorators_1.deprecate('Upload Photo')
    ], ControllerWebClient.prototype, "SetBillboardPhoto", null);
    __decorate([
        core_decorators_1.deprecate('Get Current Billboard All Photo')
    ], ControllerWebClient.prototype, "GetAdditionalBillboardInfo", null);
    return ControllerWebClient;
}());
exports.ControllerWebClient = ControllerWebClient;
//# sourceMappingURL=ControllerWebClient.js.map